<template>
  <ModalDialog
    ref="dialog"
    :labelOk="$t('participantModal.btnCreateNew')"
    :labelCancel="$t('create.dlgCancel')"
    :showCancelIcon="false"
    :displayCancelButton="true"
    :displayOkButton="false"
    @cancel="onCancel"
  >
    <!-- replace true with isPaymentComplete in displayOkButton -->
    <div class="h6 text-weight-semi-bold mb-3 text-center">
      {{ $t('participantModal.participantsWithSameEmail') }}
    </div>
    <div v-for="p in participantsWithSameEmail" :key="p.id" class="mb-3">
      <div @click="onContinueWith(p)" class="d-flex row">
        <div class="col-12 align-items-center justify-content-center d-flex">
          <Btn
            :fullWidth="true"
            @click="onContinueWith(p)"
            :label="
              $t('participantModal.continueAs') +
              ' ' +
              p.name +
              '<br/><span class=\'text-very-small\'>(' +
              p.user.email +
              ')</span>'
            "
          />
        </div>
      </div>
    </div>
    <div class="text-weight-semi-bold mb-3">
      {{ $t('participantModal.youCanCerateNewParticipant') }}
    </div>

    <div v-if="participantData" class="d-flex row">
      <div
        class="col-12 col-md-6 align-items-start justify-content-center d-flex"
      >
        <div class="block-name w-100">
          <div class="user-name text-weight-semi-bold d-flex">
            {{ participantData.participantName }}
          </div>
          <div class="user-name d-flex text-very-small">
            ({{ participantData.participantEmail }})
          </div>
        </div>
      </div>
      <div
        class="col-12 col-md-6 align-items-center justify-content-start d-flex"
      >
        <Btn
          @click.native="onCreateNewUser()"
          :label="$t('participantModal.btnCreateNew')"
        />
      </div>
      <div class="hint m-2">
        <span class="text-weight-semi-bold">{{ $t('general.hint') }}</span>
        {{ $t('participantModal.hintNewLink') }}
      </div>
    </div>
  </ModalDialog>
</template>

<script>
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import { mapState } from 'vuex';

export default {
  name: 'ModalSameEmailDialog',
  props: ['participantsWithSameEmail', 'participantData'],
  mixins: [modalParticipantMixins],

  computed: {
    ...mapState({
      curInvitation: (state) => state.curInvitation,
      poll: (state) => state.poll.poll,
    }),
  },

  methods: {
    openModal() {
      this.$refs.dialog.openModal(null);
    },

    onContinueWith(p) {
      this.changeUrlToInvitationLink(p);
      this.$refs.dialog.closeModal();
    },

    onCreateNewUser() {
      // create new user
      console.error('Create new user', this.participantData);
      this.addEmailParticipant(this.participantData);
      this.$refs.dialog.closeModal();
    },
    onCancel() {
      this.$refs.dialog.closeModal();
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/style';

.user-name {
  border-bottom: 0px solid $primary;
  width: 100%;
}
</style>
